import { PanelCard, Track, EmptyState } from '../../../components/ui';
import { ChartLine } from 'lucide-react';
import type { AcademicDashboardResponse } from '../../../api/types';
import { pct } from './format';

export default function SubjectsCard({ d, className = '' }: { d: AcademicDashboardResponse; className?: string }) {
  const rows = [...d.subjects].sort((a, b) => (a.avg_score ?? 101) - (b.avg_score ?? 101));
  return (
    <PanelCard className={className} title="Subjects" actions={<span className="text-[13px] text-muted">weakest first</span>}>
      {rows.length === 0 ? <EmptyState compact icon={<ChartLine size={22} />} title="No subject data yet" /> : (
        <ul className="flex flex-col gap-[15px]">
          {rows.map((s) => (
            <li key={s.id}>
              <div className="mb-[7px] flex justify-between"><span className="font-medium">{s.name}</span><span className="font-mono">{pct(s.avg_score)}</span></div>
              <Track value={s.avg_score ?? 0} tone={(s.avg_score ?? 0) < d.pass_score_pct + 5 ? 'accent' : 'slate'} label={`${s.name} average`} />
            </li>
          ))}
        </ul>
      )}
    </PanelCard>
  );
}
